import { useContext, useEffect, useState } from "react";
import { getSchedules, createSchedules, updateSchedules, getSchedulesTypes, deleteSchedules } from "../services/configurations/pointsOfAttention/schedules";
import { AppContext } from "../context";

type DataResponseType = "DATA" | "ID" | "TYPES";
type ActionType = "CREATE" | "UPDATE" | "DELETE";
type translateType = "translate" | "no-translate"

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createSchedules,
        fnMsg: t("PointsOfAttention.scheduleApiCreateLabel"),
      };
      case "UPDATE":
        return {
          actionFn: updateSchedules,
          fnMsg: t("PointsOfAttention.scheduleApiUpdateLabel"),
        };
    case "DELETE":
      return {
        // deleteUser service here
        actionFn: deleteSchedules,
        fnMsg: t("PointsOfAttention.scheduleApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useSchedules = (type: DataResponseType, translation: translateType = 'translate') => {
  const {
    t,
    toast,
    appState: { selectedApp, language },
    setAppState,
  } = useContext(AppContext);
  const [dataSchedule, setDataSchedule] = useState<any | null>(null);
  const [dataScheduleTypes, setDataScheduleTypes] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFnSchedule = () => {
    setDataSchedule(null);
    setReload((prev) => prev + 1);
  };

  const scheduleAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data, selectedApp?.tenantid!))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getSchedules(selectedApp?.tenantid!))
          .then((response) => {
            const data = response?.data;
            const serviceResponse = data.map((schedule: any) => {
              return {
                ...schedule,
                day: translation === 'no-translate' ? schedule.day : `${t(`PointsOfAttention.day${schedule.day}`)}`
              }
            })
            setDataSchedule(serviceResponse);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
    if (type === "TYPES") {
      (async function () {
        await Promise.resolve(getSchedulesTypes(selectedApp?.tenantid!))
          .then((response) => {
            const data = response?.data;
            const serviceResponse = data.map((type: any) => {
              return {
                ...type,
                name: `${t(`PointsOfAttention.typeOfSchedule${type.name}`)}`
              }
            })
            setDataScheduleTypes(serviceResponse);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [t, toast, reload, type, setAppState, language]);

  return {
    dataSchedule,
    dataScheduleTypes,
    scheduleAction,
    reloadFnSchedule,
  };
};